const modalReason = {
  actionCancel: 'Stornieren',
  adminLocked: 'Admin gesperrt',
  constractTerminated: 'Vertrag beendet',
  temporarySuspended: 'Vorübergehend gesperrt',
  textAreaPlaceholder: 'Grund eingeben',
};

export default modalReason;
